import { setPromotions } from '../actions';
import { identityPayload, createReducer, forAction } from '../utils';

const initialState = [];

export default createReducer(
  [forAction(setPromotions, identityPayload)],
  initialState,
);
